import { formatDistanceToNow } from 'date-fns';
import { capitalizeFirstChar } from '../../../../utils/capitalizeFirstChar';

export function calculateTimeAgo(createdAt: string) {
	const timeAgo = formatDistanceToNow(new Date(createdAt), {
		addSuffix: true,
	});

	return capitalizeFirstChar(timeAgo);
}
